<template>
  <div id="app">
    <component :is="layout">
      <router-view :layout.sync="layout"/>
    </component>
  </div>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout'
export default {
  name: 'App',
  components: {
    DefaultLayout
  },
  data () {
    return {
      layout: 'div'
    }
  }
}
</script>
